import React, { createContext, useContext, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import api from '../../src/api/axiosConfig'; 
import { useAuth } from "./AuthContext";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  // 1. FETCH USERS
  const fetchUsers = async () => {
    try {
      const response = await api.get('/admin/users');
      setUsers(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      console.warn("Failed to load users:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!user || !user.id) {
        setUsers([]);
        setLoading(false);
    }
  }, [user]);

  // 2. CREATE USER
  const addUser = async (newUser) => {
    try {
      await api.post('/admin/users', newUser);
      if (typeof fetchUsers === 'function') {
        await fetchUsers();
      }
      return true;
    } catch (error) {
      console.error("Error creating user:", error);
      const msg = error.response?.data?.message || error.response?.data?.error || "Failed to create user";
      toast.error(msg);
      throw error; // Throw error so component knows it failed
    }
  };

  // 3. UPDATE USER
  const updateUser = async (id, updatedData) => {
    try {
      await api.put(`/admin/users/${id}`, updatedData);
      // ✅ SUCCESS TOAST REMOVED (Handled by Component)
      fetchUsers();
      return true;
    } catch (error) {
      console.error("Error updating user:", error);
      toast.error("Failed to update user");
      throw error;
    }
  };

  // 4. DELETE USER
  const deleteUser = async (id) => {
    try {
      await api.delete(`/admin/users/${id}`);
      setUsers(users.filter(u => u.id !== id));
      // ✅ SUCCESS TOAST REMOVED (Handled by Component)
      return true;
    } catch (error) {
      console.error("Error deleting user:", error);
      toast.error("Failed to delete user");
      throw error;
    }
  };

  return (
    <UserContext.Provider value={{ users, loading, addUser, updateUser, deleteUser, fetchUsers }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUsers = () => useContext(UserContext);